export const
    ERROR_RESET = 'error_reset',
    ERROR = 'error_generic',
    INFO_RESET = 'info_reset',
    INFO = 'info_generic';



// WEBPACK FOOTER //
// src/store/infos/types.js